export default __webpack_public_path__ + "static/media/disc.d363e7c6.png";